/**
 * Shared TanStack Query cache durations (tier-based).
 *
 * `staleTime` = data stays fresh (no refetch on re-visit).
 * `gcTime` = unused cache kept in memory (instant restore + background refetch).
 * Rule of thumb: `gcTime` should always exceed `staleTime`.
 */
export const CACHE_TIME = {
  LIVE: 30_000, // admin lists — near-realtime
  FRESH: 60_000, // news — updates frequently
  BALANCED: 5 * 60_000, // stats/games/roadmap — aggregated
  PERSISTENT: 15 * 60_000, // gcTime for balanced tier
  INFINITY: Number.POSITIVE_INFINITY, // feature flags
} as const
